import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { securityApi, type SecurityEvent } from '../../api/security';

export function ThreatCenterPage() {
  const [threats, setThreats] = useState<SecurityEvent[]>([]);
  const refresh = () => void securityApi.threats().then(setThreats);
  useEffect(() => { refresh(); }, []);
  const simulate = async (category: string) => {
    await securityApi.detectThreat({ category, source: 'simulation', action: 'test_detect' });
    refresh();
  };
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Threat Center</h1>
      <Link to="/security" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← SOC Hub</Link>
      <div className="mt-4 flex flex-wrap gap-2">
        {['brute_force', 'api_abuse', 'privilege_escalation', 'impossible_travel'].map((t) => (
          <button key={t} type="button" onClick={() => simulate(t)} className="rounded bg-indigo-600 px-3 py-1.5 text-sm text-white hover:bg-indigo-700">{t}</button>
        ))}
      </div>
      <div className="mt-6 overflow-x-auto rounded-xl border dark:border-slate-700">
        <table className="min-w-full text-sm"><thead className="bg-slate-50 dark:bg-slate-800"><tr><th className="px-4 py-2 text-left">Category</th><th className="px-4 py-2 text-left">Source</th><th className="px-4 py-2 text-left">Risk</th><th className="px-4 py-2 text-left">Blocked</th><th className="px-4 py-2 text-left">Time</th></tr></thead>
          <tbody>{threats.map((t) => (<tr key={t.id} className="border-t dark:border-slate-700"><td className="px-4 py-2">{t.category}</td><td className="px-4 py-2">{t.source}</td><td className="px-4 py-2">{t.risk_score}</td><td className="px-4 py-2">{t.blocked ? 'Yes' : 'No'}</td><td className="px-4 py-2">{new Date(t.occurred_at).toLocaleString()}</td></tr>))}</tbody>
        </table>
      </div>
    </div>
  );
}
